/* istanbul ignore file */

export const HEADING = 'Customer reviews';
export const NO_REVIEWS = 'No reviews for this product yet.';
export const ERROR_REVIEWS = 'Reviews are unavailable right now.';

/** Grouped with `toLocaleString('en-GB')` to match the "2,102 Product reviews" heading above it. */
export const seeAllReviewsLabel = (count: number) =>
  count === 1 ? 'View 1 review' : `View all ${count.toLocaleString('en-GB')} reviews`;

/** A cold Feefo page can take tens of seconds, and a bare skeleton that long looks broken. */
export const LOADING_REVIEWS = 'Loading reviews, this might take a while.';
